import { render, staticRenderFns } from "./b-payment.vue?vue&type=template&id=3bc94bb7&"
import script from "./b-payment.vue?vue&type=script&lang=js&"
export * from "./b-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports